// eslint-disable-next-line import/no-named-default
import { default as CreateReceiptSubmission } from "./CreateReceiptSubmission";

export default CreateReceiptSubmission;
